import {
  WIDGET_STATES,
  EMAIL_MFA_STATES,
  SMS_MFA_STATES,
  TOTP_STATES,
} from '../config/widgetStates';
import { REGISTRATION_STEPS } from '../components/CustomRegistrationFlow';

const MFA_STATES = [
  WIDGET_STATES.ENROLL_CHOICES,
  WIDGET_STATES.MFA_CHALLENGE,
  WIDGET_STATES.MFA_ENROLL,
  WIDGET_STATES.MFA_ENROLL_ACTIVATE,
  WIDGET_STATES.MFA_VERIFY,
  ...EMAIL_MFA_STATES,
  ...SMS_MFA_STATES,
  ...TOTP_STATES,
];

export const getOnboardingStep = (oktaViewState, registrationStep = null) => {
  if (oktaViewState === WIDGET_STATES.PASSWORD_RESET) {
    if (!registrationStep || registrationStep === REGISTRATION_STEPS.WELCOME) {
      return null;
    }
    return 1;
  }

  if (MFA_STATES.includes(oktaViewState)) {
    return 2;
  }

  return null;
};
